import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/shared/ui';
import type { FollowupState, SlaState, Urgency } from '@contracts/procurement';
import { SLA_LABEL, SLA_TONE, STATE_LABEL, STATE_TONE, URGENCY_LABEL } from './procurementMeta';

export function StateBadge({ state }: { state: FollowupState }) {
  return <Badge tone={STATE_TONE[state]}>{STATE_LABEL[state]}</Badge>;
}

export function SlaBadge({ sla }: { sla: SlaState }) {
  return <Badge tone={SLA_TONE[sla]}>{SLA_LABEL[sla]}</Badge>;
}

/** Solo destaca las urgentes; las normales no meten ruido visual. */
export function UrgencyBadge({ urgency }: { urgency: Urgency }) {
  if (urgency !== 'urgent') return <span className="text-slate-400">{URGENCY_LABEL.normal}</span>;
  return (
    <Badge tone="danger">
      <AlertTriangle className="h-3 w-3" />
      {URGENCY_LABEL.urgent}
    </Badge>
  );
}
